import * as React from "react";

import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { resolveInject } from "app/di";
import { IAppConfigProvider } from "app/services/config/app-config-loader.service";
import { ISparqlExecutor } from "app/services/infrastructure/sparql-executor";
import {
    SparqlResultParser,
    getRecordValue
} from "app/services/infrastructure/sparql-result-parser";
import { Search } from "app/ui/sections/search";
import { useTheme } from "app/theme-context";
import { Box } from "@mui/material";
import "./top-menu.less";

interface IComponentProps {
    quicksearch?: boolean;
}

export const TopMenu = (props: IComponentProps) => {
    const appConfig = resolveInject(IAppConfigProvider).config;
    const sparqlExecutor = resolveInject(ISparqlExecutor);
    const { cssProperties } = useTheme();
    const [name, setName] = React.useState<string>();
    const [menuAnchor, setMenuAnchor] = React.useState<null | HTMLElement>(null);
    const [version, setVersion] = React.useState<string>();

    // CHECK IF SIGN-IN OPTION IS SET TO GUEST
    const isGuest = appConfig?.signIn?.options?.[0] === "guest";

    const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        setMenuAnchor(event.currentTarget);
    };
    const handleMenuClose = () => {
        setMenuAnchor(null);
    };

    React.useEffect(() => {
        loadData(props);
    }, []);

    const loadData = async (props: IComponentProps) => {
        const sparqlResponse = await sparqlExecutor.execute(appConfig.queryOTL, []);
        const result = SparqlResultParser.parse(sparqlResponse);
        if (result.length == 0) {
            return;
        }
        const record = result[0];
        setName(getRecordValue(record, "text"));
        setVersion(getRecordValue(record, "version"));
    };

    const onSignOut = () => {
        localStorage.removeItem("user");
        location.reload();
    };

    return (
        <AppBar position="static" color="default" style={cssProperties}>
            <Toolbar>
                {/* START OF BRAND FIX */}
                <Box style={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
                    <span
                        className="ex-app-logo" // This applies custom logo styling
                        title="Linked Data Viewer"
                        onClick={() => {
                            window.location.hash = "/view";
                        }}
                        // Ensure proper alignment and growth in the Toolbar
                        style={{
                            display: "flex",
                            alignItems: "center",
                            cursor: "pointer",
                            flexGrow: 1,
                            minHeight: "64px",
                            maxWidth: "150px"
                        }}
                    />
                    <Box>
                        <Typography variant="h6" component="span" padding={"8px"}>
                            <span id="title-placeholder">{name}</span>
                            <span id="version-placeholder">{version ? ` (${version})` : ""}</span>
                        </Typography>
                        {appConfig.subtitleHTML ? (
                            <span
                                className="subtitle"
                                dangerouslySetInnerHTML={{ __html: appConfig.subtitleHTML }}
                            />
                        ) : null}
                    </Box>
                </Box>

                <Search quicksearch={props.quicksearch} />
                {/*CONDITIONAL RENDER: HIDE LOG-OUT BUTTON FOR GUESTS */}
                {!isGuest && (
                    <Button
                        variant="outlined"
                        color="inherit"
                        onClick={onSignOut}
                        title="Sign out"
                        style={{ marginLeft: 16 }}
                    >
                        Log out
                    </Button>
                )}
            </Toolbar>
        </AppBar>
    );
};
